// Global login-modal state so any component (chat composer, account actions) can prompt login
// without forcing it on watch.
import { createContext, type ReactNode, useCallback, useContext, useState } from "react";

interface LoginModalCtx {
  open: boolean;
  openLogin: () => void;
  closeLogin: () => void;
}

const Ctx = createContext<LoginModalCtx>({ open: false, openLogin: () => {}, closeLogin: () => {} });

export function LoginModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <Ctx.Provider value={{ open, openLogin: () => setOpen(true), closeLogin: () => setOpen(false) }}>
      {children}
    </Ctx.Provider>
  );
}

export const useLoginModal = () => useContext(Ctx);
